<template>
    <div  class="all-height">
        <el-main class="all-height" v-if="flag">
            <div class="operation-bar">
                <h1>入库清单</h1>
                <div class="operation-bar-right">
                    <div class="input-box">
                        <i class="el-icon-search" @click="query"></i>
                        <input type="text" v-model="keyword" placeholder="请输入订单号"/>
                    </div>
                </div>
            </div>

            <div class="table-box cursorPointer">
                <el-table :data="orderList"
                          height="calc(100% - 55px)"
                          :header-cell-style="{background:'#4885CA',color: 'white'}"
                          @row-dblclick = "rowDblclick"
                >
                    <el-table-column width="200" prop="deliveryNo" label="入库编号" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="200" prop="sapInvoiceNo" label="内向交货单号" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="200" prop="orderNo" label="订单编号" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="200"  prop="deliveryDate" label="入库日期" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="sapToCompName" label="采购方" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                </el-table>
                <div class="table-page">
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page.current"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </el-main>
        <detail :sap-invoice-no="sapInvoiceNo" :is-lock="isLock" @closeDetail="closeDetail"  v-else></detail>

    </div>

</template>

<script>
import detail from './delivered-detail';
export default {
    name: 'delivered-order',
    components: {
        detail
    },
    data() {
        return {
            orderList: [],
            page: {
                current: 1,
                pageSize: 15,
                pageSizes: [15,30,50,100],
                total: 0
            },
            keyword: '',
            deliveryId: '',
            sapInvoiceNo: '',
            flag: true,
            isLock: false,
        };
    },

    methods: {
        handleSizeChange(val) {
            this.page.pageSize = val;
            this.loadOrderList();
        },

        handleCurrentChange(val) {
            this.page.current = val;
            this.loadOrderList();
        },

        loadOrderList() {
            this.$store.dispatch('order/order/getDOList', {
                current: this.page.current,
                size: this.page.pageSize,
                orderNo: this.keyword,
                status: '0'
            }).then((res)=> {
                this.orderList = res.records;
                this.page.total = res.total;
            })
        },

        query() {
            this.page.current = 1;
            this.loadOrderList();
        },

        rowDblclick(row) {
            // this.deliveryId = row.id;
            this.sapInvoiceNo = row.sapInvoiceNo;
            this.isLock = row.status !== '0';
            this.flag = !this.flag;
        },

        closeDetail() {
            this.flag = !this.flag;
        }
    },
    created() {
        this.loadOrderList();
    }
}

</script>

<style scoped>
.table-box{
    position: relative;
    margin-top: 5px;
    background-color: white;
    height: calc(100% - 35px);
    width: 100%;
}
.table-page {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 10px;
}
.el-table .el-button{
    padding: 0;
}
.cell i {
    font-size: 25px;
    cursor: pointer;
}
.cell i:hover {
    color: #5ED1FD;
}
.textArea-box {
    max-height: 300px;
    overflow-y: scroll;
}
/deep/ .cursorPointer tbody tr:hover {cursor: pointer }
</style>
